import React from 'react';
import Statusbar from '../../components/statusbar';
import { isFullscreen, cancelFullscreen, comparatorViewByOrder } from '../../services/utils';
import { OnlineMarketsTabsHeader } from '../../components/OnlineMarketsTabsHeader';
import { GridView } from '../../components/OnlineMarketsGridView';
import { GridViewFooter } from '../../components/OnlineMarketsGridViewFooter';
import { ListView } from '../../components/OnlineMarketsListView';
import { CustomViewType } from '../../constants/customViews';

const getDefaultProductId = (savedProductsIds, allProducts) => {
    const productsMap = allProducts ? allProducts.reduce((agg, p) => ({ ...agg, [p.id]: p }), {}) : {};
    const filteredIds = savedProductsIds && savedProductsIds.filter(id => productsMap[id]);
    return filteredIds && filteredIds.length ? filteredIds[0] : null;
};

const findSelectedTabIndex = (needleId, stack) => {
    for (let i = 0; i < stack.length; i++) {
        const stackId = stack[i].id;
        if (needleId === stackId) {
            return i;
        }
    }

    return null;
};

class MarketLogPopup extends React.Component {
    constructor(props) {
        super(props);

        // If the setting is not already set, we need to set it.
        if (JSON.parse(localStorage.getItem('volumeOn')) == null) {
            localStorage.setItem('volumeOn', 'true');
        }

        this.statusbarPrevId = '';
        this.state = {
            selectedTab: 0,
            selectedTabType: null,
            tabs: [],
            volumeOn: JSON.parse(localStorage.getItem('volumeOn')),
        };
    }

    equals(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    isObject(obj) {
        return Object.prototype.toString.call(obj) === '[object Object]';
    }

    objectsNotEqual(first, second) {
        if (first.length !== second.length) {
            return true;
        }
        first.every((view, index) => {
            return (
                view.id !== second[index].id ||
                view.user_id !== second[index].user_id ||
                view.name !== second[index].name ||
                view.type !== second[index].type ||
                view.version !== second[index].version
            );
        });
        return false;
    }

    resetView(tabs) {
        const newState = {};
        newState.tabs = tabs;
        newState.selectedTabType = CustomViewType.LIST;
        newState.selectedTab = null;
        if (this.objectsNotEqual(tabs, this.state.tabs) || newState.selectedTab !== this.state.selectedTab) {
            this.setState(newState);
        }
    }

    componentDidUpdate() {
        const { user, selectedView } = this.props;
        const { userInfo } = user;
        const views = userInfo.views;

        if (!views) return;

        const tabs = views
            .filter(view => view.view_type === CustomViewType.GRID)
            .sort(comparatorViewByOrder)
            .concat(views.filter(view => view.view_type === CustomViewType.LIST));

        if (!selectedView) {
            this.resetView(tabs);
            return;
        }

        const viewId = selectedView.id || undefined;

        const newState = {};

        const tabExists = tabs.map(tab => tab.id).includes(viewId);
        if (!tabExists) {
            if (this.state.selectedTabType !== CustomViewType.LIST) {
                newState.selectedTabType = CustomViewType.LIST;
            }
            if (this.state.selectedTab !== null) {
                newState.selectedTab = null;
            }
            if (selectedView != this.state.selectedView) {
                newState.selectedView = selectedView;
            }
        } else {
            const selectedTab = findSelectedTabIndex(viewId, tabs);
            const selectedTabType = selectedView.view_type;
            if (selectedTab !== this.state.selectedTab) {
                newState.selectedTab = selectedTab;
            }
            if (selectedTabType !== this.state.selectedTabType) {
                newState.selectedTabType = selectedTabType;
            }
            if (selectedView != this.state.selectedView) {
                newState.selectedView = selectedView;
            }
        }
        if (!this.state.tabs.length || this.objectsNotEqual(tabs, this.state.tabs)) {
            newState.tabs = tabs;
        }

        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    }

    toogleVolume = () => {
        const volumeOn = !JSON.parse(localStorage.getItem('volumeOn'));

        localStorage.setItem('volumeOn', JSON.stringify(volumeOn));
        this.setState({ ...this.state, volumeOn });
    };

    handleCreateOrderClick = () => {
        const { args, user } = this.props;
        const { products } = user.userInfo;
        const curProdId = args && args.include ? getDefaultProductId(args.include.products, products) : null;

        this.props.showOrderPopup('create', { product_id: curProdId });
    };

    handleHideClick = () => {
        cancelFullscreen();
        this.props.hide();
    };

    render() {
        const { isVisible, fullscreen, statusbar, actions, user, freights, showOrderPopup } = this.props;

        return (
            <div
                className={'worklog-container ' + (isFullscreen() ? 'worklog-container-fullscreen' : '')}
                style={{ display: isVisible ? 'block' : 'none' }}
            >
                <img onClick={this.handleHideClick} src="/img/close.png" className="worklog-close" />
                <img onClick={this.handleCreateOrderClick} src="/img/add.png" className="worklog-add" />
                <img onClick={fullscreen} src="/img/fullscreen.png" className="worklog-fullscreen" />
                <img
                    onClick={this.toogleVolume}
                    src={this.state.volumeOn ? '/img/volume_on.png' : '/img/volume_off.png'}
                    className="worklog-volume"
                />
                <div className="worklog-inner-container">
                    <div className="worklog-content new-table">
                        <OnlineMarketsTabsHeader
                            actions={actions}
                            selectedTab={this.state.selectedTab}
                            tabs={this.state.tabs}
                            marketOrderNotifikation={this.props.marketOrderNotifikation}
                        />
                        {this.state.selectedTabType === CustomViewType.GRID && (
                            <GridView
                                view={this.state.tabs[this.state.selectedTab]}
                                user={user}
                                data={this.props.data}
                                showOrderPopup={showOrderPopup}
                                getOrder={this.props.getOrder}
                                placeOrder={this.props.placeOrder}
                                callDH={this.props.callDH}
                                getMarketLog={this.props.getMarketLog}
                                requestStatusbarData={this.props.requestStatusbarData}
                                showStatusbar={this.props.showStatusbar}
                                hideStatusbar={this.props.hideStatusbar}
                            />
                        )}
                        {this.state.selectedTabType === CustomViewType.GRID && (
                            <GridViewFooter actions={actions} freights={this.props.freights} />
                        )}
                        {this.state.selectedTabType === CustomViewType.LIST && (
                            <ListView
                                actions={actions}
                                user={user}
                                args={this.props.args}
                                data={this.props.data}
                                showOrderPopup={showOrderPopup}
                                getOrder={this.props.getOrder}
                                placeOrder={this.props.placeOrder}
                                callDH={this.props.callDH}
                                getMarketLog={this.props.getMarketLog}
                                requestStatusbarData={this.props.requestStatusbarData}
                                showStatusbar={this.props.showStatusbar}
                                hideStatusbar={this.props.hideStatusbar}
                            />
                        )}
                    </div>
                </div>
                <Statusbar statusbar={statusbar} absolutePosition={true} freights={freights} />
            </div>
        );
    }
}

export default MarketLogPopup;



// WEBPACK FOOTER //
// ./source/screens/markets/marketLogPopup.js